import { symbol } from "./highlightSymbols";

export function showPopup(response, view, event) {
    view.popup.when(() => {
      if (response.length > 0) {
        
        view.openPopup({
          features: response,
          location: event.mapPoint
        });
    
        const sidebar = document.getElementById("sidebar");
        if (sidebar) {
          document.querySelector("#features-widget > calcite-flow > calcite-flow-item").shadowRoot.querySelector("calcite-panel").shadowRoot.querySelector("article > footer").style = "order: -1";
          document.getElementById('detailstab').click();
    
          if (sidebar.classList.contains("collapsed")) {
            document.getElementById('sidebarExpand').click();
          }
          document.getElementById("detailTip").innerHTML = "";
        }
      }
      else {
        document.getElementById("detailTip").innerHTML = "No results.";
      }
    })
  }